import React, { useRef, useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Tab,
  Nav,
  Card,
  CardBody,
  Form,
  Accordion,
} from "react-bootstrap";
import SearchableDropdown from "../../Component/SearchableDropdown";
import Attachments from "../../Component/TemplateAttachments";

import { useParams } from 'react-router-dom';

import Header from "../../Component/Header";
import placeholderImg from "../../Asset/Images/circle-placeholder.svg";
import placeholderImgLarge from "../../Asset/Images/placeholder-large-icon.png";
import plusIcon from "../../Asset/Images/plus-icon.svg";
import deleteIcon from "../../Asset/Images/delete-icon.svg";
import attachmentIcon from "../../Asset/Images/attachment-icon.svg";
import crossIcon from "../../Asset/Images/cross-icon.svg";
import downArrowIcon from "../../Asset/Images/down-arrow-icon.svg";
import uploadIcon from "../../Asset/Images/upload-img-icon.svg";
import messageIcon from "../../Asset/Images/message-icon.svg";
import checkIcon from "../../Asset/Images/check-circle-green-icon.svg";
import crossIconWeb from "../../Asset/Images/crose-grey-circle-icon.svg";
import SubHeader from "../../Component/SubHeader";
import Modal from "react-bootstrap/Modal";
import FullScreenLoader from "../../Component/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import MobileFooter from "../../Component/MobileFooter";


import { postDeploy, getParts, uploadImg, getLocations, getEmails, getRequestById, updateStatus, updateRequest, deleteAsset } from "../../Services/deploy";

import "./index.css";

// ---- Shared allowed image MIME types ----
const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
  "image/gif",
];
const ALLOWED_IMAGE_ACCEPT = "image/png, image/jpeg, image/jpg, image/webp, image/gif";

function Swap() {
  const { templateId } = useParams();
  let navigate = useNavigate();
  const fileInputRefs = useRef([]);
  const additionalFileInputRefs = useRef([]);
  const vehicleFrontRef = useRef(null);
  const vehicleBackRef = useRef(null);
  const vehicleSide1Ref = useRef(null);
  const vehicleSide2Ref = useRef(null);
  const [show, setShow] = useState(false);
  const [additionalForm, setAdditionalForm] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState(null);
  const [selectedPreviewAdditional, setSelectedPreviewAdditional] =
    useState(null);
  const [vehicleFrontimage, setVehicleFrontimage] = useState(null);
  const [vehicleBackimage, setVehicleBackimage] = useState(null);
  const [vehicleFrontName, setVehicleFrontName] = useState(null);
  const [vehicleBackName, setVehicleBackName] = useState(null);

  const [vehicleside1image, setVehicleside1image] = useState(null);
  const [vehicleside2image, setVehicleside2image] = useState(null);
  const [vehicleFrontPreview, setVehicleFrontPreview] = useState(null);
  const [vehicleBackPreview, setVehicleBackPreview] = useState(null);
  const [vehicleside1Preview, setVehicleside1Preview] = useState(null);
  const [vehicleside2Preview, setVehicleside2Preview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [partsList, setPartsList] = useState([]);
  const [assetType, setAssetType] = useState(1);
  const [additionalEmail, setAdditionalEmail] = useState('');
  const [additionalEmailError, setAdditionalEmailError] = useState("");
  const [additionalEmails, setAdditionalEmails] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [status, setStaus] = useState('');
  const [additionalEmailsList, setAdditionalEmailsList] = useState([]);

  // ---- Vehicle preview modal state ----
  const [showVehiclePreview, setShowVehiclePreview] = useState(false);
  const [vehiclePreviewSrc, setVehiclePreviewSrc] = useState(null);
  const [vehiclePreviewName, setVehiclePreviewName] = useState("");


  const [brokenAsset, setBrokenAsset] = useState([
    {
      id: 0,
      AssetID: "",
      AssetNo: "",
      AssetBlob: "",
      to: "",
      Going_Too: ''
    },
  ]);

  const [inputOptionList, setInputOptionList] = useState([

  ]);

  const [chargeBackCustomers, setChargeBackCustomers] = useState([
    {
      id: 0,
      name: "",
    },
  ]);

  const [formData, setFormData] = useState({
    rigNuber: "",
    laydown: "",
    reason: "",
    comingfrom: "",
    esr: "",
    note: ""
  });

  const [truckingToRig, setTruckingToRig] = useState({
    company: "",
    driverName: "",
    phone: "",
    bol: "",
    payforTruck: "",
    po: "",
  });

  const [additionaltruckingToRig, setAdditionaltruckingToRig] = useState({
    company: "",
    driverName: "",
    phone: "",
    bol: "",
    payforTruck: "",
    po: "",
  });

  let [assests, setAssets] = useState([
    {
      id: 0,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      value: "",
      AssetID: null,
      AssetNo: "",
      AssetBlob: "",
      Coming_From: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    },
  ]);

  let [additionalAsset, setAdditionalAsset] = useState([
    {
      id: 0,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      from: "",
      value: "",
      AssetID: null,
      AssetNo: "",
      AssetBlob: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    },
  ]);

  const heading =
    "SWAP: Basin/Laydown-Yard => Rig/Jobsite => Basin/Laydown-Yard Shipments ";

  // ---- Central lock flag ----
  const isAdmin = localStorage.role === "Admin";
  const isCompleted = status === "Completed";
  const isLocked = templateId ? (!isAdmin || isCompleted) : false;

  // ---- NEW: Asset-specific lock flag ----
  // In edit mode, the Asset / Broken Asset sections are ALWAYS locked.
  const isAssetLocked = templateId ? true : isLocked;

  useEffect(() => {
    fetchParts();
    fetchEmail()
    if (templateId) {
      fetchRequestDetails()
    }
  }, []);

  let handleComplete = async () => {
    if (isLocked) return;
    let payload = {
      "RequestID": templateId,
      "Status": "Completed"
    }
    setIsLoading(true)
    let res = await updateStatus(payload, localStorage.access_token)
    setIsLoading(false)
    if (res.data && res.status == 200) {
      fetchRequestDetails()
      toast.success(res.data)
    }
  }

  let fetchEmail = async () => {
    let res = await getEmails(localStorage.access_token)
    if (res.data && res.data.status_code == 200) {
      setUserEmails(res.data?.data)
    }
  }


  let fetchRequestDetails = async () => {
    let payload = {
      ID: templateId
    }
    let res = await getRequestById(payload, localStorage.access_token)
    if (res.status == 200) {
      let data = res.data.RequestDetails
      setStaus(data?.Status)
      setFormData({
        rigNuber: data?.JobSiteNumber,
        laydown: "",
        reason: "",
        comingfrom: "",
        esr: data?.ESR,
        note: data?.Note
      })

      setTruckingToRig({
        company: data?.Company,
        driverName: data?.DriverName,
        phone: data?.PhoneNumber,
        bol: data?.BOL,
        payforTruck: data?.PayForTruck,
        po: data?.S3SPO,
      })

      setAdditionalEmailsList(data?.additional_email_recipients?.length ? data?.additional_email_recipients : [])
      setVehicleFrontPreview(data?.VehicleFrontBlob)
      setVehicleBackPreview(data?.VehicleBackBlob)
      setAdditionalEmails(data?.additional_email_recipients)


      let assetTemp = []
      data?.Asset?.map((ast, i) => {
        let obj = {
          ID: ast?.ID,
          id: `${Date.now()}-${i}`,
          name: "S3S",
          img: ast?.AssetBlob,
          imgName: ast?.AssetBlob.substring(0, 10),
          imgPreview: ast?.AssetBlob,
          value: "",
          AssetID: ast?.AssetID,
          AssetNo: ast?.AssetNo,
          AssetBlob: ast?.AssetBlob,
          Coming_From: ast?.Coming_From,
          Broken_AssetID: "",
          Broken_AssetNo: "",
          Broken_AssetBlob: "",
        }
        assetTemp.push(obj)
      })
      setAssets(assetTemp)

      setAdditionaltruckingToRig({
        company: data?.ADDT_Company,
        driverName: data?.ADDT_DriverName,
        phone: data?.ADDT_PhoneNumber,
        bol: data?.ADDT_BOL,
        payforTruck: data?.ADDT_PayForTruck,
        po: data?.ADDT_S3SPO,
      })

      if (data?.AdditionalAsset?.length) {
        let addtnAssetTemp = []
        data?.AdditionalAsset?.map((ast, i) => {
          let obj = {
            ID: ast?.ID,
            id: `${Date.now()}-${i}`,
            name: "S3S",
            img: ast?.AssetBlob,
            imgName: ast?.AssetBlob.substring(0, 10),
            imgPreview: ast?.AssetBlob,
            from: "",
            value: "",
            AssetID: ast?.AssetID,
            AssetNo: ast?.AssetNo,
            AssetBlob: ast?.AssetBlob,
            Broken_AssetID: "",
            Broken_AssetNo: "",
            Broken_AssetBlob: "",
          }
          addtnAssetTemp.push(obj)
        })
        setAdditionalAsset(addtnAssetTemp)
      }

      if (data?.BrokenAsset?.length) {
        let addtnAssetTemp = []
        data?.BrokenAsset?.map((ast, i) => {
          let obj = {
            id: ast?.ID,
            ID: ast?.ID,
            AssetID: ast?.AssetID,
            AssetNo: ast?.AssetNo,
            AssetBlob: ast?.AssetBlob,
            Going_Too: ast?.Going_Too
          }
          addtnAssetTemp.push(obj)
        })
        setBrokenAsset(addtnAssetTemp)
      }

      if (data?.Chargeback?.length) {
        setChargeBackCustomers(data?.Chargeback)
      }

    }
  }


  let handleImagePreview = (index, type) => {
    setShow(true);
    setSelectedPreview(index);
    setAssetType(type);
  };

  // ---- Vehicle preview handlers ----
  const handleVehiclePreview = (src, name) => {
    if (!src) return;
    setVehiclePreviewSrc(src);
    setVehiclePreviewName(name || "Vehicle Image");
    setShowVehiclePreview(true);
  };

  const handleVehiclePreviewClose = () => {
    setShowVehiclePreview(false);
    setVehiclePreviewSrc(null);
    setVehiclePreviewName("");
  };

  const handleAttachmentClick = (index) => {
    if (isAssetLocked) return;
    fileInputRefs.current[index]?.click();
  };
  const handleAdditionalAttachmentClick = (index) => {
    if (isAssetLocked) return;
    additionalFileInputRefs.current[index]?.click();
  };

  let handleAddImg = (index) => {
    if (isAssetLocked) return;
    let temp = [...assests];
    let obj = {
      id: index + 1,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      value: "",
      AssetID: null,
      Coming_From: "",
      AssetNo: "",
      AssetBlob: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    };
    temp.push(obj);
    setAssets(temp);
  };

  let handleAddImgAdditional = (index) => {
    if (isAssetLocked) return;
    let temp = [...additionalAsset];
    let obj = {
      id: index + 1,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      value: "",
      from: "",
      AssetID: null,
      AssetNo: "",
      AssetBlob: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    };
    temp.push(obj);
    setAdditionalAsset(temp);
  };

  let handleRemoveImg = (val) => {
    if (isAssetLocked) return;
    if (templateId) {
      handleDeleteAsset(val.ID)
      setAssets((prevAssets) => prevAssets.filter((item) => item.id !== val.id));
    } else {
      setAssets((prevAssets) => prevAssets.filter((item) => item.id !== val.id));
    }
  };


  let handleRemoveImgAdditional = (i, val) => {
    if (isAssetLocked) return;
    if (templateId) {
      handleDeleteAsset(val.ID)
      let newPreview = selectedPreviewAdditional - 1;
      setSelectedPreviewAdditional(newPreview);
      let temp = [...additionalAsset];
      let arr = temp.filter((val, index) => i != index);
      setAdditionalAsset(arr);
    } else {
      let newPreview = selectedPreviewAdditional - 1;
      setSelectedPreviewAdditional(newPreview);
      let temp = [...additionalAsset];
      let arr = temp.filter((val, index) => i != index);
      setAdditionalAsset(arr);
    }

  };

  let handleDeleteAsset = async (id) => {
    let payload = { "ID": id }
    let token = localStorage.access_token
    setIsLoading(true)
    let res = await deleteAsset(payload, token)
    if (res && res.status == '200') {
      toast.success(res.data)
    }
    setIsLoading(false)
  }
  let handleRemoveImgPreview = (index, type) => {
    if (isAssetLocked) return;
    if ((type = "1")) {
      let temp = [...assests];
      temp[index].img = "";
      temp[index].imgName = "";
      temp[index].imgPreview = "";
      temp[index].AssetBlob = "";
      setAssets(temp);
    } else {
      let temp = [...additionalAsset];
      temp[index].img = "";
      temp[index].imgName = "";
      temp[index].imgPreview = "";
      temp[index].AssetBlob = "";
      setAdditionalAsset(temp);
    }
  };

  let handleRemoveImgPreviewAdditional = (index) => {
    if (isAssetLocked) return;
    let temp = [...additionalAsset];
    temp[index].img = "";
    temp[index].imgName = "";
    temp[index].imgPreview = "";
    setAdditionalAsset(temp);
  };

  // ============================================================
  //  handleFileChange — Image-only validation for assets
  // ============================================================
  const handleFileChange = async (event, index, type) => {
    if (isAssetLocked) return;
    const file = event.target.files?.[0];
    if (!file) return;

    // Strict image-only validation
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.");
      event.target.value = ""; // allow re-selecting the same file later
      return;
    }

    if (type == "1") {
      let temp = [...assests];
      const fileUrl = URL.createObjectURL(file);
      temp[index].img = file;
      temp[index].imgName = file.name;
      temp[index].imgPreview = fileUrl;

      let data = await uploadFile(file, localStorage.access_token);
      temp[index].AssetBlob = data.data;
      setAssets(temp);
    } else {
      let temp = [...additionalAsset];
      const fileUrl = URL.createObjectURL(file);
      temp[index].img = file;
      temp[index].imgName = file.name;
      temp[index].imgPreview = fileUrl;

      let data = await uploadFile(file, localStorage.access_token);
      temp[index].AssetBlob = data.data;
      setAdditionalAsset(temp);
    }
  };

  const handleFileChangeAdditional = async (event, index) => {
    if (isAssetLocked) return;
    const file = event.target.files?.[0];
    if (!file) return;

    // Strict image-only validation
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.");
      event.target.value = "";
      return;
    }

    let temp = [...additionalAsset];
    const fileUrl = URL.createObjectURL(file);
    temp[index].img = file;
    temp[index].imgName = file.name;
    let data = await uploadFile(file, localStorage.access_token);
    temp[index].AssetBlob = data.data;
    setAdditionalAsset(temp);
  };

  let uploadFile = async (file) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file, file.name);
    let res = await uploadImg(formData, localStorage.access_token);
    setIsLoading(false);
    return res;
  };
  const handleDivClick = (val) => {
    if (isLocked) return;
    val.current.click();
  };

  // ============================================================
  //  handleVehicleFileChange — Image-only validation for vehicles
  // ============================================================
  const handleVehicleFileChange = async (event, val) => {
    if (isLocked) return;
    const file = event?.target?.files?.[0] || event?.files?.[0];
    if (!file) return;

    // Strict image-only validation
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.");
      if (event && event.target) event.target.value = "";
      return;
    }

    const fileUrl = URL.createObjectURL(file);
    if (val == "vehicleFrontRef") {
      setVehicleFrontName(file.name)
      setVehicleFrontPreview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleFrontimage(data.data);
    } else if (val == "vehicleBackRef") {
      setVehicleBackName(file.name)
      setVehicleBackPreview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleBackimage(data.data);
    } else if (val == "vehicleSide1Ref") {
      setVehicleside1Preview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleside1image(data.data);
    } else {
      setVehicleside2Preview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleside2image(data.data);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let handleChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  let handleRigChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setTruckingToRig({
      ...truckingToRig,
      [name]: value,
    });
  };

  let handleAdditionalRigChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setAdditionaltruckingToRig({
      ...additionaltruckingToRig,
      [name]: value,
    });
  };

  let handleFromChange = (e, i) => {
    if (isAssetLocked) return;
    let temp = [...assests];
    temp[i].Coming_From = e.target.value;
    setAssets(temp);
  };

  let handleToChange = (e, i) => {
    if (isAssetLocked) return;
    let temp = [...brokenAsset];
    temp[i].Going_Too = e.target.value;
    setBrokenAsset(temp);
  };


  let handleSubmit = async (type) => {
    if (isLocked) return;
    let filteredAsset = assests.map((item) => ({
      AssetID: item.AssetID,
      AssetNo: item.AssetNo,
      AssetBlob: item.AssetBlob,
      Coming_From: item.Coming_From,
      ID: item?.ID,
    }));
    let filteredArr = filteredAsset.filter(
      (item) => item.AssetID != null && item.AssetID !== ""
    );

    let filteredAdditionalAsset = additionalAsset.map((item) => ({
      AssetID: item.AssetID,
      AssetNo: item.AssetNo,
      AssetBlob: item.AssetBlob,
      Coming_From: item.from,
      ID: item?.ID,
      Going_Too: "",
    }));
    let filteredAdditionalArr = filteredAdditionalAsset.filter(
      (item) => item.AssetID != null && item.AssetID !== ""
    );
    const requiredFields = [
      { label: "Esr", value: formData.esr },
      { label: "Rig/Jobsite Number", value: formData.rigNuber },
      { label: "Asset", value: filteredArr.length },
      { label: "Trucking Company", value: truckingToRig.company },
      { label: "Driver Name", value: truckingToRig.driverName },
      { label: "Phone Number", value: truckingToRig.phone },
    ];

    for (let field of requiredFields) {
      if (
        field.value == null ||
        (typeof field.value === "string" && field.value.trim() === "") ||
        (typeof field.value === "number" && field.value === 0)
      ) {
        toast.warning(`Input ${field.label} field`);
        return;
      }
    }

    let payload = {
      RequestType: "SWAP",
      Asset: filteredArr,
      AdditionalAsset: [],
      BrokenAsset: brokenAsset,
      Chargeback: chargeBackCustomers.length == 1 ? chargeBackCustomers[0].name === "" ? [] : chargeBackCustomers.map((obj) => obj.name) : chargeBackCustomers.map((obj) => obj.name),
      ShippedTo: formData.laydown,
      ShippedFrom: formData.rigNuber,
      ADDED_Because: formData.reason,
      ADDT_ShipTo: "",
      addShipTo: "",
      Company: truckingToRig.company,
      JobSiteNumber: formData.rigNuber,
      DriverName: truckingToRig.driverName,
      PhoneNumber: truckingToRig.phone,
      BOL: truckingToRig.bol,
      PayForTruck: truckingToRig.payforTruck,
      S3SPO: truckingToRig.po,
      ADDT_Company: additionaltruckingToRig.company,
      ADDT_DriverName: additionaltruckingToRig.driverName,
      ADDT_PhoneNumber: additionaltruckingToRig.phone,
      ADDT_BOL: additionaltruckingToRig.bol,
      ADDT_PayForTruck: additionaltruckingToRig.payforTruck,
      ADDT_S3SPO: additionaltruckingToRig.po,
      VehicleFrontBlob: vehicleFrontimage ? vehicleFrontimage : "",
      VehicleBackBlob: vehicleBackimage ? vehicleBackimage : "",
      VehicleSide1Blob: vehicleside1image ? vehicleside1image : "",
      VehicleSide2Blob: vehicleside2image ? vehicleside2image : "",
      RETURNED: "",
      ADDED_Jobsite: "",
      ModifiedByUser: localStorage.role ? localStorage.role : "",
      ESR: formData.esr,
      additional_email_recipients: [...additionalEmails, ...additionalEmailsList]
    };
    if (type == 'save') {
      setIsLoading(true);
      let res = await postDeploy(payload, localStorage.access_token);
      setIsLoading(false);

      if (res) {
        if (res.status === 200) {
          toast.success("Template data submitted!");
          setTimeout(() => {
            navigate("/dashboard");
          }, 2000);
        }
      }
      else {
        toast.error("Internal server error!");
      }
    }
    else {
      payload.Chargeback = chargeBackCustomers.length ? chargeBackCustomers : []
      payload.RequestID = templateId
      payload.Note = formData.note
      setIsLoading(true)
      let res = await updateRequest(payload, localStorage.access_token)
      setIsLoading(false)
      console.log(" res.statusText ", res.statusText)
      if (res && res.statusText == "OK") {
        toast.success(res.data)
      }
    }

  };

  let resetData = () => {
    setTruckingToRig({
      company: "",
      driverName: "",
      phone: "",
      bol: "",
      payforTruck: "",
      po: "",
    });

    setFormData({
      rigNuber: "",
      laydown: "",
    });

    setAssets([
      {
        id: 0,
        name: "S3S",
        img: "",
        imgName: "",
        imgPreview: "",
        value: "",
      },
    ]);
    setVehicleFrontPreview("");
    setVehicleBackPreview("");
    setVehicleside1Preview("");
    setVehicleside2Preview("");
  };

  const handleSelect = (selectedValue, index, type) => {
    if (isAssetLocked) return;
    // Determine which state array to update
    let stateArray, setStateFunction;
    if (type == 1) {
      stateArray = assests;
      setStateFunction = setAssets;
    } else if (type == 2) {
      stateArray = additionalAsset;
      setStateFunction = setAdditionalAsset;
    } else {
      stateArray = brokenAsset;
      setStateFunction = setBrokenAsset;
    }

    // Create updated array
    const updatedArray = [...stateArray];

    // Handle clearing
    if (!selectedValue && selectedValue !== 0) {
      updatedArray[index] = {
        ...updatedArray[index],
        AssetID: null,
        AssetNo: "",
      };
      setStateFunction(updatedArray);
      return;
    }

    // Find the object (by value or label)
    const obj = partsList.find(item =>
      item.value == selectedValue || item.label == selectedValue
    );

    if (obj) {
      updatedArray[index] = {
        ...updatedArray[index],
        AssetID: obj.value,
        AssetNo: obj.label,
      };
      setStateFunction(updatedArray);
    }
  };

  let fetchParts = async () => {
    let res = await getParts(localStorage.access_token);
    let locationRes = await getLocations(localStorage.access_token)

    if (locationRes && locationRes.data) {
      setInputOptionList(locationRes.data.response_body)
    }
    let temp = [];
    if (res.data) {
      res.data.map((val) => {
        let obj = { value: val.AssetID, label: val.AssetNo };
        temp.push(obj);
      });
    }
    setPartsList(temp);
  };

  let handleAdditionalAssetChange = (e, index) => {
    if (isAssetLocked) return;
    let { value } = e.target;
    let temp = [...additionalAsset];
    temp[index].from = value;
    setAdditionalAsset(temp);
  };

  let handleChargebackAdd = () => {
    if (isLocked) return;
    let temp = [...chargeBackCustomers];
    let obj = {
      name: "",
      id: chargeBackCustomers.length + 1,
    };
    temp.push(obj);
    setChargeBackCustomers(temp);
  };

  let handleBrokenAdd = () => {
    if (isAssetLocked) return;
    let temp = [...brokenAsset];
    let obj = {
      id: brokenAsset.length + 1,
      AssetID: "",
      AssetNo: "",
      AssetBlob: "",
      Going_Too: "",
    };
    temp.push(obj);
    setBrokenAsset(temp);
  };

  let handleChargebackRemove = (index) => {
    if (isLocked) return;
    let temp = [...chargeBackCustomers];

    let data = temp.filter((val) => val.id != index);
    setChargeBackCustomers(data);
  };

  let handleBrokenemove = (index) => {
    if (isAssetLocked) return;
    let temp = [...brokenAsset];
    let data = temp.filter((val) => val.id != index);
    setBrokenAsset(data);
  };

  let handleChargeBackNameChange = (e, index) => {
    if (isLocked) return;
    let { value } = e.target;
    let temp = [...chargeBackCustomers];
    temp[index].name = value;
    setChargeBackCustomers(temp);
  };

  let handleInputSelect = (e, name) => {
    if (isLocked) return;
    setFormData({
      ...formData,
      [name]: e
    })
  }

  let validateEmail = (email) => {
    if (!email) {
      return false
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      return false
    } else {
      return true
    }
  }


  let handleAddEmail = () => {
    if (isLocked) return;
    let check = validateEmail(additionalEmail)
    if (!check) {
      setAdditionalEmailError("Enter valid email id")
    } else {
      let temp = [...additionalEmailsList]
      temp.push(additionalEmail)
      setAdditionalEmailsList(temp)
      setAdditionalEmail('')
    }
  }

  let handleRemoveEmail = (indexToRemove) => {
    if (isLocked) return;
    const filteredArr = additionalEmailsList.filter((_, index) => index !== indexToRemove);
    setAdditionalEmailsList(filteredArr)
  }

  let handleEmailListChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target
    setAdditionalEmail(value)
    setAdditionalEmailError('')
  }

  let handleAddEmailChange = (val) => {
    if (isLocked) return;
    if (additionalEmails.includes(val)) {
      let temp = additionalEmails.filter(ele => ele !== val)
      setAdditionalEmails(temp)
    } else {
      let temp = [...additionalEmails]
      temp.push(val)
      setAdditionalEmails(temp)
    }

  }

  let handleUpdate = async () => {
    if (isLocked) return;
    let payload = {
      "RequestID": templateId,
      "Note": formData.note
    }
    setIsLoading(true)
    let res = await updateRequest(payload)
    setIsLoading(false)
    console.log(" res.statusText ", res.statusText)
    if (res && res.statusText == "OK") {
      toast.success(res.data)
    }
  }

   const handleVehicleRemove = (key) => {
    if (isLocked) return;
    switch (key) {
      case "vehicleFrontRef":
        setVehicleFrontPreview(null);
        setVehicleFrontName(null);
        setVehicleFrontimage(null);
        break;
      case "vehicleBackRef":
        setVehicleBackPreview(null);
        setVehicleBackName(null);
        setVehicleBackimage(null);
        break;
      case "vehicleSide1Ref":
        setVehicleside1Preview(null);
        setVehicleside1image(null);
        break;
      case "vehicleSide2Ref":
        setVehicleside2Preview(null);
        setVehicleside2image(null);
        break;
      default:
        break;
    }
  };

  return (
    <div className="wrapper">
      {isLoading ? <FullScreenLoader></FullScreenLoader> : null}
      <Header />
      <div className="container-layout">
        <div className="heading-section">
          <Container fluid>

            <Row>
              <Col xs="12">
                <div class="d-flex flex-wrap align-items-center">
                  <h2 className="main-title-h">Email Templates</h2>
                  {
                    templateId ?
                      <div className="side-viewbutton-lyt ps-4">
                        {
                          status ?

                            status == 'Completed' ?
                              <span className="btn-cmn-yt-2 ms-2">Completed</span>
                              :
                              <span className="btn-cmn-yt-1">Request Submitted</span>
                            :
                            null

                        }

                      </div>
                      :
                      null
                  }

                </div>
              </Col>
            </Row>


          </Container>
        </div>
        <div className="email-section-area">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="email-tab-wapper">
                  <div id="">
                    {
                      templateId ? null : <div>
                        <SubHeader />
                      </div>
                    }

                    <div className="content-tab--layout">
                      <div className="tab-items--content">
                        <Card>
                          <Card.Header className="cardheader--wgt"><h3 className="heading-dep-small">{heading}</h3></Card.Header>
                          <CardBody>
                            <div className="email-shrt-disc">
                              <p className="text-black">Hello,</p>
                              <p>
                                The following asset, being shipped today, will
                                be used for an ESR{" "}
                                <span className="me-1"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>

                                <div className="d-inline-block mx-md-2 my-2 input-width-area">
                                  <input disabled={isLocked} value={formData.esr} name="esr" type="text" onChange={(e) => handleChange(e)} placeholder="Text input" class="form-select-value form-control" />
                                </div>
                                <span className="text-bold-highlight">
                                  SWAP
                                </span>
                                {" "}
                                on Rig/Site#
                                <span className="me-1"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>

                                <div className="d-inline-block mx-md-2 my-2 input-width-area">
                                  <input disabled={isLocked} value={formData.rigNuber} name="rigNuber" type="text" onChange={(e) => handleChange(e)} placeholder="Text input" class="form-select-value form-control" />
                                </div>
                                {" "}
                                (an existing S3S jobsite)
                              </p>
                            </div>
                            <div className="addition-level-mts">
                              <div className="container-wgtrow">
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item eventKey="0">
                                    <Accordion.Header className="heading-lbl-waps">Add additional email IDs: <span className="short-linetxt-hd"><i className="fas fa-exclamation-circle me-1"></i> BC Admins automatically receive all notifications for requests submitted through this application</span> </Accordion.Header>
                                    <Accordion.Body>
                                      <div className="wrapper-grid--colart">
                                        <Row>
                                          {
                                            userEmails && userEmails.map((val, i) => {
                                              return (
                                                <Col xs={12} md={4} lg={4}>
                                                  <div className="list-check-filed-wp">
                                                    <h3 className="main-head-lst">{val.key}</h3>
                                                    <ul className="mult-check-wps--emnt">
                                                      {
                                                        val.values && val.values.map((ele, index) => {
                                                          return (
                                                            <li className="list-checkwps-dep">
                                                              <input disabled={isLocked} checked={additionalEmails.includes(ele) ? true : false} onChange={() => handleAddEmailChange(ele)} type="checkbox" className="check-lst-wp" /><span className="label-lst-nvm">{ele}</span>
                                                            </li>
                                                          )
                                                        })
                                                      }

                                                    </ul>

                                                  </div>
                                                </Col>

                                              )
                                            })
                                          }
                                        </Row>
                                        <Row>
                                          <Col xs={12} md={6}>
                                            <div className="addition-field-requre">
                                              <div className="field-wps-mt">
                                                <label className="label-txt--add">Add the additional email ID <i></i> </label>
                                                <div className="position-relative d-flex">
                                                  <input disabled={isLocked} onChange={(e) => handleEmailListChange(e)} value={additionalEmail} name="additionalEmail" type="email" placeholder="Enter the Email ID" className="form-control control-addtion-wp" />

                                                  <button onClick={handleAddEmail} disabled={isLocked} className="add-btn-mt">ADD</button>
                                                  <span className="msg-icon-wtp"><img src={messageIcon} /></span>
                                                </div>
                                              </div>
                                              {
                                                additionalEmailError ? <p style={{ fontSize: '12px', color: 'red' }} >{additionalEmailError}</p> : null

                                              }
                                              <div className="list-add-ftm">
                                                <ul className="mult-lstmtv">
                                                  {
                                                    additionalEmailsList.length ?
                                                      additionalEmailsList.map((val, i) => {
                                                        return (
                                                          <li className="lst-bxwp"><span class="icon-check-wth"><img src={checkIcon} alt="icon" /></span>{val}{!isLocked && (<button className="btn border-0 p-0 btn-cross-adnt"><img onClick={() => handleRemoveEmail(i)} src={crossIconWeb} alt="icon" /></button>)}</li>

                                                        )
                                                      })
                                                      :
                                                      null

                                                  }
                                                </ul>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </div>
                            </div>
                            <Row>
                              <Col xs={12} md={6} className="card-space-bottom">
                                <Card className="card-stage-bg">
                                  <CardBody>
                                    <Row>
                                      <Col xs={12} md={6}>
                                        <Card className="mb-3 card-height-equal">
                                          <CardBody>
                                            <div className="emial-heading-wt">
                                              <h3 className="heading-yt-wp">
                                                New Assets
                                              </h3>
                                            </div>
                                            <div class="mult-assets-changer">
                                              {assests.map((val, index) => {
                                                return (
                                                  <>
                                                    <div className="border-line-last bottom-line-asts">
                                                      <div
                                                        className="assets-add"
                                                        key={val.id}
                                                      >
                                                        {" "}
                                                        <div className="d-flex align-items-center column-wty mb-2">
                                                          <div className="left-select-value">
                                                            <SearchableDropdown
                                                              disabled={isAssetLocked}
                                                              options={partsList}
                                                              onSelect={(e) =>
                                                                handleSelect(
                                                                  e,
                                                                  index,
                                                                  "1"
                                                                )
                                                              }
                                                              placeholder="Search parts..."
                                                              selectedValue={val.AssetNo}
                                                            />
                                                            {index == 0 ? (
                                                              <span
                                                                className="require-dot-txt"
                                                                style={{ color: "red" }}
                                                              >
                                                                *
                                                              </span>
                                                            )
                                                              : null}
                                                          </div>
                                                          <>
                                                            {
                                                              !isAssetLocked ?
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-wt--comn"
                                                                  onClick={() =>
                                                                    handleAttachmentClick(index)
                                                                  }
                                                                >
                                                                  <img
                                                                    src={attachmentIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                                :
                                                                null
                                                            }

                                                            {index == assests.length - 1 ? (
                                                              !isAssetLocked ?
                                                                <button
                                                                  onClick={() =>
                                                                    handleAddImg(index)
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={plusIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                                :
                                                                null

                                                            ) : (
                                                              !isAssetLocked ?
                                                                <button
                                                                  onClick={() =>
                                                                    handleRemoveImg(val)
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={deleteIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                                :
                                                                null
                                                            )}
                                                          </>

                                                          {/* ==== Assets file input — image only ==== */}
                                                          <input
                                                            type="file"
                                                            accept={ALLOWED_IMAGE_ACCEPT}
                                                            ref={(el) =>
                                                            (fileInputRefs.current[
                                                              index
                                                            ] = el)
                                                            }
                                                            style={{ display: "none" }}
                                                            onChange={(e) =>
                                                              handleFileChange(
                                                                e,
                                                                index,
                                                                "1"
                                                              )
                                                            }
                                                          />
                                                        </div>
                                                        <div>
                                                        </div>
                                                        <div className="list-add-img">
                                                          <div className="list-imgadded-yt">
                                                            {val.imgName ? (
                                                              <div className="img-bx-wgt">
                                                                <img
                                                                  className="place-img--emt"
                                                                  src={placeholderImg}
                                                                  alt=""
                                                                />
                                                                <span
                                                                  style={{
                                                                    cursor: "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    handleImagePreview(
                                                                      index,
                                                                      "1"
                                                                    )
                                                                  }
                                                                  className="img-txt-name"
                                                                >
                                                                  {val.imgName}
                                                                </span>
                                                                {
                                                                  !isAssetLocked ?
                                                                    <>
                                                                      <span
                                                                        onClick={() =>
                                                                          handleRemoveImgPreview(
                                                                            index,
                                                                            "2"
                                                                          )
                                                                        }
                                                                        className="cross-img-btn"
                                                                      >
                                                                        <img
                                                                          src={crossIcon}
                                                                          alt=""
                                                                        />
                                                                      </span>
                                                                    </>
                                                                    :
                                                                    null
                                                                }

                                                              </div>
                                                            ) : null}
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="d-inline-block w-100">
                                                        <label class="label-txt-vl">From</label>
                                                        <input disabled={isAssetLocked} value={assests[index].Coming_From} name="Coming_From" type="text"
                                                          onChange={(e) =>
                                                            handleFromChange(e, index)
                                                          }
                                                          placeholder="Text input" class="form-select-value form-control" />
                                                      </div>
                                                    </div>
                                                  </>

                                                );
                                              })}
                                            </div>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                      <Col xs={12} md={6}>
                                        <Card className="mb-3 card-height-equal">
                                          <CardBody>
                                            <div className="mt-wap--gtr">
                                              <h3 className="heading-yt-wp">
                                                Trucking to Rig
                                              </h3>
                                              <div className="form-card--lyt">
                                                <Form>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Company{" "}
                                                      <span
                                                        style={{ color: "red" }}
                                                      >
                                                        *
                                                      </span>
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="company"
                                                        value={
                                                          truckingToRig.company
                                                        }
                                                        type="text"
                                                        placeholder="Input Company"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Driver Name{" "}
                                                      <span
                                                        style={{ color: "red" }}
                                                      >
                                                        *
                                                      </span>
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="driverName"
                                                        value={
                                                          truckingToRig.driverName
                                                        }
                                                        type="text"
                                                        placeholder="Input Name"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Phone Number{" "}
                                                      <span
                                                        style={{ color: "red" }}
                                                      >
                                                        *
                                                      </span>
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="phone"
                                                        value={truckingToRig.phone}
                                                        type="text"
                                                        placeholder="Input Phone"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Bill of Lading Number (BOL){" "}
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="bol"
                                                        value={truckingToRig.bol}
                                                        type="text"
                                                        placeholder="Input BOL"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Pay for the Truck{" "}
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="payforTruck"
                                                        value={
                                                          truckingToRig.payforTruck
                                                        }
                                                        type="text"
                                                        placeholder="Input Pay"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group controlId="">
                                                    <Form.Label className="label-txt-vl">
                                                      S3S PO#{" "}
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="po"
                                                        value={truckingToRig.po}
                                                        type="text"
                                                        placeholder="Input Po"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                </Form>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col xs={12} md={6}>
                                        <div className="mt-wap--gtr">
                                          <h3 className="heading-yt-wp">
                                            List the broken Asset
                                          </h3>
                                          {brokenAsset.map((val, index) => {
                                            return (
                                              <>
                                                <div className="border-line-last">
                                                  <div
                                                    className="assets-add mb-0"
                                                    key={val.id}
                                                  >
                                                    <div className="d-flex align-items-center column-wty mb-2">
                                                      <div className="left-select-valu pe-0 flex-grow-1">
                                                        <SearchableDropdown
                                                          selectedValue={val.AssetNo}
                                                          disabled={isAssetLocked}
                                                          options={partsList}
                                                          onSelect={(e) =>
                                                            handleSelect(
                                                              e,
                                                              index,
                                                              "3"
                                                            )
                                                          }
                                                          placeholder="Search parts..."
                                                        />
                                                      </div>
                                                      {
                                                        !isAssetLocked ?
                                                          index ==
                                                            brokenAsset.length - 1 ? (
                                                            <button
                                                              onClick={handleBrokenAdd}
                                                              type="button"
                                                              className="btn btn-wt--comn ms-1"
                                                            >
                                                              <img
                                                                src={plusIcon}
                                                                alt="icon"
                                                              />
                                                            </button>
                                                          ) : (
                                                            <button
                                                              onClick={() =>
                                                                handleBrokenemove(val.id)
                                                              }
                                                              type="button"
                                                              className="btn btn-wt--comn ms-1"
                                                            >
                                                              <img
                                                                src={deleteIcon}
                                                                alt="icon"
                                                              />
                                                            </button>
                                                          )
                                                          :
                                                          null
                                                      }
                                                    </div>
                                                  </div>

                                                  <>
                                                    <div className="d-inline-block w-100">
                                                      <label class="label-txt-vl">To</label>
                                                      <input disabled={isAssetLocked} value={brokenAsset[index].Going_Too} name="to" type="text" onChange={(e) =>
                                                        handleToChange(e, index)
                                                      } placeholder="" class="form-select-value form-control" />
                                                    </div>
                                                  </>
                                                </div>
                                              </>
                                            );
                                          })}

                                        </div>
                                      </Col>

                                      <Col xs={12} md={6}>
                                        <div className="mt-wap--gtr">
                                          <h3 className="heading-yt-wp">
                                            List All chargebacks to the customer
                                          </h3>
                                          {chargeBackCustomers.map((val, i) => {
                                            return (
                                              <Form.Group
                                                style={{ marginBottom: "10px" }}
                                                className="d-flex align-items-center"
                                                controlId=""
                                              >
                                                <Form.Control
                                                  disabled={isLocked}
                                                  onChange={(e) =>
                                                    handleChargeBackNameChange(e, i)
                                                  }
                                                  type="text"
                                                  placeholder="Input Name"
                                                  value={val.name}
                                                  className="input-control-ast"
                                                />
                                                {
                                                  !isLocked ?
                                                    i ==
                                                      chargeBackCustomers.length - 1 ? (
                                                      <button
                                                        onClick={handleChargebackAdd}
                                                        type="button"
                                                        className="btn btn-wt--comn ms-1"
                                                      >
                                                        <img
                                                          src={plusIcon}
                                                          alt="icon"
                                                        />
                                                      </button>
                                                    ) : (
                                                      <button
                                                        onClick={() =>
                                                          handleChargebackRemove(val.id)
                                                        }
                                                        type="button"
                                                        className="btn btn-wt--comn ms-1"
                                                      >
                                                        <img
                                                          src={deleteIcon}
                                                          alt="icon"
                                                        />
                                                      </button>
                                                    )
                                                    :
                                                    null
                                                }
                                              </Form.Group>
                                            );
                                          })}
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                {additionalForm ? (
                                  <>
                                    <Card className="card-stage-bg mt-4">
                                      <CardBody className="pb-1">
                                        <Row>
                                          <Col xs={12} md={6}>
                                            <Card className="mb-3 card-height-equal">
                                              <CardBody className="px-2">
                                                <div className="emial-heading-wt px-3">
                                                  <h3 className="heading-yt-wp">
                                                    Additional Assets
                                                  </h3>
                                                </div>
                                                <div className="card-wgtwap">
                                                  {additionalAsset.map(
                                                    (val, index) => {
                                                      return (
                                                        <div
                                                          className="assets-add"
                                                          key={val.id}
                                                        >
                                                          <div className="d-flex align-items-center column-wty mb-2">
                                                            <div className="left-select-value">
                                                              <SearchableDropdown
                                                                options={partsList}
                                                                onSelect={(e) =>
                                                                  handleSelect(
                                                                    e,
                                                                    index,
                                                                    "2"
                                                                  )
                                                                }
                                                                placeholder="Search parts..."
                                                                disabled={isAssetLocked}
                                                              />
                                                            </div>
                                                            {!isAssetLocked && (
                                                              <button
                                                                type="button"
                                                                className="btn btn-wt--comn"
                                                                onClick={() =>
                                                                  handleAdditionalAttachmentClick(
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                <img
                                                                  src={attachmentIcon}
                                                                  alt="icon"
                                                                />
                                                              </button>
                                                            )}
                                                            {index ==
                                                              additionalAsset.length -
                                                              1 ? (
                                                              !isAssetLocked ? (
                                                                <button
                                                                  onClick={() =>
                                                                    handleAddImgAdditional(
                                                                      index
                                                                    )
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={plusIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                              ) : null
                                                            ) : (
                                                              !isAssetLocked ? (
                                                                <button
                                                                  onClick={() =>
                                                                    handleRemoveImgAdditional(
                                                                      index, val
                                                                    )
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={deleteIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                              ) : null
                                                            )}

                                                            {/* ==== Additional asset input — image only ==== */}
                                                            <input
                                                              type="file"
                                                              accept={ALLOWED_IMAGE_ACCEPT}
                                                              ref={(el) =>
                                                              (additionalFileInputRefs.current[
                                                                index
                                                              ] = el)
                                                              }
                                                              style={{
                                                                display: "none",
                                                              }}
                                                              onChange={(e) =>
                                                                handleFileChange(
                                                                  e,
                                                                  index,
                                                                  "2"
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                          <div className="list-add-img">
                                                            <div className="list-imgadded-yt">
                                                              {val.imgName ? (
                                                                <div className="img-bx-wgt">
                                                                  <img
                                                                    className="place-img--emt"
                                                                    src={
                                                                      placeholderImg
                                                                    }
                                                                    alt=""
                                                                  />
                                                                  <span
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                      handleImagePreview(
                                                                        index,
                                                                        "2"
                                                                      )
                                                                    }
                                                                    className="img-txt-name"
                                                                  >
                                                                    {val.imgName}
                                                                  </span>
                                                                  {!isAssetLocked && (
                                                                    <span
                                                                      onClick={() =>
                                                                        handleRemoveImgPreview(
                                                                          index,
                                                                          "2"
                                                                        )
                                                                      }
                                                                      className="cross-img-btn"
                                                                    >
                                                                      <img
                                                                        src={
                                                                          crossIcon
                                                                        }
                                                                        alt=""
                                                                      />
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              ) : null}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Col>
                                          <Col xs={12} md={6}>
                                            <Card className="mb-3 card-height-equal">
                                              <CardBody>
                                                <div className="mt-wap--gtr">
                                                  <h3 className="heading-yt-wp">
                                                    Additional Trucking to Rig
                                                  </h3>
                                                  <div className="form-card--lyt">
                                                    <Form>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Company
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="company"
                                                          value={
                                                            additionaltruckingToRig.company
                                                          }
                                                          type="text"
                                                          placeholder="Input Company"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Driver Name
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="driverName"
                                                          value={
                                                            additionaltruckingToRig.driverName
                                                          }
                                                          type="text"
                                                          placeholder="Input Name"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Phone Number
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="phone"
                                                          value={
                                                            additionaltruckingToRig.phone
                                                          }
                                                          type="text"
                                                          placeholder="Input Phone"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Bill of Lading Number
                                                          (BOL)
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="bol"
                                                          value={
                                                            additionaltruckingToRig.bol
                                                          }
                                                          type="text"
                                                          placeholder="Input BOL"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Pay for the Truck
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="payforTruck"
                                                          value={
                                                            additionaltruckingToRig.payforTruck
                                                          }
                                                          type="text"
                                                          placeholder="Input Pay"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group controlId="">
                                                        <Form.Label className="label-txt-vl">
                                                          S3S PO#
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="po"
                                                          value={
                                                            additionaltruckingToRig.po
                                                          }
                                                          type="text"
                                                          placeholder="Input Po"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                    </Form>
                                                  </div>
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Col>
                                          <Col xs={12}>
                                            <Row>
                                              <Col xs={12} md={6}>
                                                <div className="mt-wap--gtr">
                                                  <h3 className="heading-yt-wp">
                                                    List the broken Asset
                                                  </h3>
                                                  {brokenAsset.map((val, index) => {
                                                    return (
                                                      <>
                                                        <div
                                                          className="assets-add"
                                                          key={val.id}
                                                        >
                                                          <div className="d-flex align-items-center column-wty mb-2">
                                                            <div className="left-select-valu pe-0">
                                                              <SearchableDropdown
                                                                options={partsList}
                                                                onSelect={(e) =>
                                                                  handleSelect(
                                                                    e,
                                                                    index,
                                                                    "3"
                                                                  )
                                                                }
                                                                placeholder="Search parts..."
                                                                disabled={isAssetLocked}
                                                              />
                                                            </div>
                                                            {!isAssetLocked && (
                                                              index ==
                                                                brokenAsset.length - 1 ? (
                                                                <button
                                                                  onClick={handleBrokenAdd}
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={plusIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                              ) : (
                                                                <button
                                                                  onClick={() =>
                                                                    handleBrokenemove(val.id)
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={deleteIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                              )
                                                            )}
                                                          </div>
                                                        </div>
                                                      </>
                                                    );
                                                  })}
                                                </div>
                                              </Col>

                                              <Col xs={12} md={6}>
                                                <div className="mt-wap--gtr">
                                                  <h3 className="heading-yt-wp">
                                                    List All chargebacks to the customer
                                                  </h3>
                                                  {chargeBackCustomers.map((val, i) => {
                                                    return (
                                                      <Form.Group
                                                        style={{ marginBottom: "10px" }}
                                                        className="d-flex align-items-center"
                                                        controlId=""
                                                      >
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={(e) =>
                                                            handleChargeBackNameChange(e, i)
                                                          }
                                                          type="text"
                                                          placeholder="Input Name"
                                                          value={val.name}
                                                          className="input-control-ast"
                                                        />
                                                        {!isLocked && (
                                                          i ==
                                                            chargeBackCustomers.length - 1 ? (
                                                            <button
                                                              onClick={handleChargebackAdd}
                                                              type="button"
                                                              className="btn btn-wt--comn ms-1"
                                                            >
                                                              <img
                                                                src={plusIcon}
                                                                alt="icon"
                                                              />
                                                            </button>
                                                          ) : (
                                                            <button
                                                              onClick={() =>
                                                                handleChargebackRemove(val.id)
                                                              }
                                                              type="button"
                                                              className="btn btn-wt--comn ms-1"
                                                            >
                                                              <img
                                                                src={deleteIcon}
                                                                alt="icon"
                                                              />
                                                            </button>
                                                          )
                                                        )}
                                                      </Form.Group>
                                                    );
                                                  })}
                                                </div>
                                              </Col>
                                            </Row>
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col xs={12} md={6}>
                                <Attachments
                                  vehicleFrontRef={vehicleFrontRef}
                                  vehicleBackRef={vehicleBackRef}
                                  vehicleSide1Ref={vehicleSide1Ref}
                                  vehicleSide2Ref={vehicleSide2Ref}
                                  handleVehicleFileChange={handleVehicleFileChange}
                                  handleDivClick={handleDivClick}
                                  vehicleFrontPreview={vehicleFrontPreview}
                                  vehicleBackPreview={vehicleBackPreview}
                                  vehicleside1Preview={vehicleside1Preview}
                                  vehicleside2Preview={vehicleside2Preview}
                                  vehicleFrontName={vehicleFrontName}
                                  vehicleBackName={vehicleBackName}
                                  handleVehiclePreview={handleVehiclePreview}
                                  handleVehicleRemove={handleVehicleRemove}
                                  templateId={templateId}
                                  isLocked={isLocked}
                                />
                              </Col>
                            </Row>
                            <Row>

                            </Row>
                          </CardBody>
                        </Card>
                        <div className="bottom-submit-action">
                          <Row>

                            <Col xs={12} md={6}>
                              {
                                templateId && !isLocked ?
                                  <div className="note-content-text">
                                    <Form.Label style={{ color: '#092e56' }} className="label-txt-vl">
                                      Comment
                                    </Form.Label>
                                    <textarea
                                      rows={5}
                                      placeholder={templateId ? "Enter note" : "Text input"}
                                      disabled={isLocked}
                                      name="note"
                                      value={formData.note}
                                      onChange={(e) => handleChange(e)}
                                      className="form-select-value form-control"
                                    />

                                  </div>
                                  :
                                  null
                              }

                            </Col>

                            <Col xs={12} md={6}>
                              <div className="text-start text-md-end mt-3 mt-md-0">
                                {
                                  templateId && !isLocked ?
                                    <button
                                      onClick={() => handleSubmit('update')}
                                      type="submit"
                                      className="btn btn-submit-btn me-2"
                                    >
                                      Save
                                    </button>
                                    :
                                    null
                                }
                                {
                                  templateId ?
                                    (
                                      isAdmin && !isCompleted ?
                                        <button
                                          onClick={() => handleComplete()}
                                          type="submit"
                                          className="btn btn-submit-btn"
                                        >
                                          Mark as complete
                                        </button>
                                        :
                                        null

                                    )

                                    :
                                    <button
                                      onClick={() => handleSubmit('save')}
                                      type="submit"
                                      className="btn btn-submit-btn ms-2"
                                    >
                                      Submit
                                    </button>
                                }
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* =====================================================
          Assets Preview Modal — Improved UI
          ===================================================== */}
      <Modal
        show={show}
        size="lg"
        aria-labelledby="asset-preview-title"
        centered
        onHide={handleClose}
        contentClassName="asset-preview-modal-content"
        dialogClassName="asset-preview-modal-dialog"
        backdropClassName="asset-preview-backdrop"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="asset-preview-modal-header border-0"
        >
          <Modal.Title id="asset-preview-title" className="asset-preview-modal-title">
            <span className="asset-preview-title-icon">
              <i className="fas fa-file-image"></i>
            </span>
            <span className="asset-preview-title-text">
              {assetType == 1 ? "Asset Attachment" : "Additional Asset Attachment"}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="asset-preview-modal-body">
          {(() => {
            const currentItem =
              assetType == 1
                ? assests[selectedPreview]
                : additionalAsset[selectedPreview];

            const previewSrc = currentItem?.imgPreview || "";
            const previewName = currentItem?.imgName || "Asset Image";

            return (
              <>
                <div className="asset-preview-image-wrapper">
                  {previewSrc ? (
                    <img
                      src={previewSrc}
                      alt={previewName}
                      className="asset-preview-image"
                    />
                  ) : (
                    <div className="asset-preview-empty">
                      <i className="fas fa-image fa-3x mb-3"></i>
                      <p>No image to preview</p>
                    </div>
                  )}
                </div>

                {previewSrc && (
                  <div className="asset-preview-footer">
                    <span className="asset-preview-filename" title={previewName}>
                      <i className="fas fa-paperclip me-2"></i>
                      {previewName}
                    </span>
                    <a
                      href={previewSrc}
                      download={previewName}
                      className="asset-preview-download-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-download me-2"></i>
                      Download
                    </a>
                  </div>
                )}
              </>
            );
          })()}
        </Modal.Body>
      </Modal>

      {/* =====================================================
          Vehicle Preview Modal — Improved UI
          ===================================================== */}
      <Modal
        show={showVehiclePreview}
        size="lg"
        aria-labelledby="vehicle-preview-title"
        centered
        onHide={handleVehiclePreviewClose}
        contentClassName="vehicle-preview-modal-content"
        dialogClassName="vehicle-preview-modal-dialog"
        backdropClassName="vehicle-preview-backdrop"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="vehicle-preview-modal-header border-0"
        >
          <Modal.Title id="vehicle-preview-title" className="vehicle-preview-modal-title">
            <span className="vehicle-preview-title-icon">
              <i className="fas fa-image"></i>
            </span>
            <span className="vehicle-preview-title-text">
              {vehiclePreviewName || "Vehicle Image Preview"}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="vehicle-preview-modal-body">
          <div className="vehicle-preview-image-wrapper">
            {vehiclePreviewSrc ? (
              <img
                src={vehiclePreviewSrc}
                alt={vehiclePreviewName || "Vehicle preview"}
                className="vehicle-preview-image"
              />
            ) : (
              <div className="vehicle-preview-empty">
                <i className="fas fa-image fa-3x mb-3"></i>
                <p>No image to preview</p>
              </div>
            )}
          </div>

          {vehiclePreviewSrc && (
            <div className="vehicle-preview-footer">
              <span className="vehicle-preview-filename" title={vehiclePreviewName}>
                <i className="fas fa-paperclip me-2"></i>
                {vehiclePreviewName || "Vehicle Image"}
              </span>
              <a
                href={vehiclePreviewSrc}
                download={vehiclePreviewName || "vehicle-image"}
                className="vehicle-preview-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-download me-2"></i>
                Download
              </a>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <MobileFooter></MobileFooter>
    </div>
  );
}

export default Swap;